import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown, Activity } from "lucide-react";

const GoalDeltaIndicator = ({ userId }) => {
  const [deltaInfo, setDeltaInfo] = useState(null);

  useEffect(() => {
    fetchDeltaInfo();
    const interval = setInterval(fetchDeltaInfo, 30000);
    return () => clearInterval(interval);
  }, [userId]);

  const fetchDeltaInfo = async () => {
    try {
      const response = await axios.get(`${API}/agent/goal-delta/${userId}`);
      setDeltaInfo(response.data);
    } catch (error) {
      console.error("Error fetching goal delta:", error);
    }
  };

  if (!deltaInfo) return null;

  const getIntensityColor = (intensity) => {
    switch (intensity) {
      case "urgent": return "bg-red-500/20 text-red-400 border-red-500/50";
      case "aggressive": return "bg-orange-500/20 text-orange-400 border-orange-500/50";
      case "steady": return "bg-yellow-500/20 text-yellow-400 border-yellow-500/50";
      case "maintain": return "bg-green-500/20 text-green-400 border-green-500/50";
      default: return "bg-gray-500/20 text-gray-400 border-gray-500/50";
    }
  };

  const getIntensityIcon = (intensity) => {
    if (intensity === "urgent" || intensity === "aggressive") {
      return <TrendingUp className="h-4 w-4" />;
    } else if (intensity === "maintain") {
      return <Activity className="h-4 w-4" />;
    }
    return <TrendingDown className="h-4 w-4" />;
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="goal-delta-indicator">
      <div className="bg-[#0f1419] border border-gray-800/50 rounded-lg p-4 shadow-xl backdrop-blur-lg">
        <div className="flex items-center gap-3">
          <Badge className={`${getIntensityColor(deltaInfo.intensity)} border px-3 py-1 flex items-center gap-2`}>
            {getIntensityIcon(deltaInfo.intensity)}
            <span className="capitalize font-semibold">{deltaInfo.intensity}</span>
          </Badge>
          <div className="text-right">
            <p className="text-xs text-gray-400">Gap to Goal</p>
            <p className="text-sm font-bold text-white">
              ${(deltaInfo.delta / 1000).toFixed(0)}K
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-800">
          <p className="text-xs text-gray-500">
            Agent Frequency: <span className="text-[#3dd9c5] font-semibold capitalize">{deltaInfo.actionFrequency.replace('_', ' ')}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoalDeltaIndicator;
